module.exports = __webpack_public_path__ + "Flag-531.1a6738d35a5a16350c2031a60917fdd8.svg";